import { css } from 'styled-components';
import { themeGet, is } from '../../../theme/utils';
import { ButtonBaseProps } from '../Button';

const primary = css<ButtonBaseProps>`
  background-color: ${themeGet.colors('primary')};
  color: ${themeGet.colors('white')};
  &:active {
    background-color: ${themeGet.colors('primaryDark')};
  }
  ${is('disabled')`
    background-color: ${themeGet.colors('swirl')};
  `}
`;

export default primary;
